import { AxiosResponse } from "axios";
import { ResType } from "../interfaces";
import AxiosRequest from "./api";
import { metaDataUTMHandler } from "../helpers/commonFunctions";

// Extract query params from the URL
const urlParams = new URLSearchParams(window.location.search);
const cartId = urlParams.get("cartId");
const modelId = urlParams.get("post_id");
const paymentSecret = urlParams.get("paymentSecret");

// Generate metadata cookies
const metaDataCookies = metaDataUTMHandler();

// Build the API URL outside the function
const baseApiUrl = process.env.REACT_APP_PAYMENT_API || "https://api.sooqdev3.com/v2.1";
const paymentFlowUrl = `${baseApiUrl}/checkout/payment-flow/select?${metaDataCookies}&paymentSecret=${paymentSecret}&cartId=${cartId}&modelId=${modelId}`;

const PaymentFlow = async (
  body: {
    type: string;
    pos: string; // Position from query params
  }
| {
    type: string;
    productAssignId: string; // ProductAssignId from query params
    pos: string; // Position from query params
    duration: string; // Duration from query params
  },
  token: string
): Promise<AxiosResponse<ResType>> => {
  return AxiosRequest<ResType>(paymentFlowUrl, "POST", body, token);
};

export { PaymentFlow };
